/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import omit from 'lodash/omit';
/**
 * Configurable navigator factory.
 * Allows you to configure the current navigator instance via `.configure({ ... })`.
 * Everytime a new navigator instance is created the configuration will also be applied.
 */
export class ConfigurableNavigatorFactory {
    /**
     * constructor
     * @param creator a function that builds the real control e.g. (c,s) => {return new OrbitControl(c);}
     */
    constructor(creator) {
        this._curNavInstance = null;
        this._navigatorConfig = null;
        this._creator = creator;
    }
    /**
     * builds a navigator
     * @param camera the camera to manipulate
     * @param scene the scene (e.g. for scanning)
     */
    build(camera, scene) {
        const nav = this._curNavInstance = this._creator(camera, scene);
        this._configureCurNavigator();
        return nav;
    }
    configure(navigatorConfig) {
        // tslint:disable-next-line:prefer-object-spread
        this._navigatorConfig = Object.assign(this._navigatorConfig || {}, navigatorConfig);
        this._configureCurNavigator();
    }
    _configureCurNavigator() {
        const nav = this._curNavInstance;
        const cfg = this._navigatorConfig;
        if (nav != null && cfg != null) {
            Object.assign(nav, omit(cfg, ['enable', 'dispose']));
            if ('enable' in cfg) {
                nav.enable(cfg.enable);
            }
        }
    }
}
//# sourceMappingURL=ConfigurableNavigatorFactory.js.map